<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.pa-3
        v-btn(color="transparent" icon small @click='showModal = false')
          eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary700" width="22" height="22")
        div.h6.basic800--text.ml-4 {{ $t('order') }} # {{ lead.rid }}
        v-spacer
        template(v-if="lead.status === 'processed'")
          v-btn.button-AA-small(data-v-step='TourOrderDetails-1' v-if="!isReady" outlined small color="success500" height="32" :style="`background-color: ${$vuetify.theme.themes[$theme].successT08}`" @click="markAsReady") {{ $t('mark_ready') }}
          v-btn.button-AA-small(data-v-step='TourOrderDetails-1' v-else-if="lead.pickup" outlined small color="success500" height="32" :style="`background-color: ${$vuetify.theme.themes[$theme].successT08}`" @click="markAsReceived") {{ $t('mark_picked_up') }}
          v-btn.button-AA-small(data-v-step='TourOrderDetails-1' v-else outlined small color="success500" height="32" :style="`background-color: ${$vuetify.theme.themes[$theme].successT08}`" @click="checkMarkShipped") {{ $t('mark_shipped') }}
        template(v-if="lead.status === 'shipped'")
          v-btn.button-AA-small(outlined small color="success500" height="32" :style="`background-color: ${$vuetify.theme.themes[$theme].successT08}`" @click="markAsReceived") {{ $t('mark_delivered') }}
      v-card-text.pt-0.pb-6.px-0
        div.p2.basic600--text.px-4.mb-2 {{ $t('created') }} {{ (lead.processed_at || lead.created) | convertServerDate }} {{ $t('from') }} {{ lead.form.type === 'store' ? 'Yezza Store' : lead.form.name }}
        div.d-flex.align-center.px-4.py-2(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`")
          template(v-if="lead.status === 'processed'")
            v-chip.button-AA-tiny.text-uppercase.mr-1(v-if="!isReady" x-small color="info400" style="height: 20px; border-radius: 10px;" dark) {{ $t('processing') }}
            v-chip.button-AA-tiny.text-uppercase.mr-1(v-else x-small color="success400" style="height: 20px; border-radius: 10px;" dark) {{ $t('ready') }}
            v-chip.button-AA-tiny.text-uppercase(v-if="isArranged" x-small color="success400" :style="`height: 20px; border-radius: 10px; background-color: ${$vuetify.theme.themes[$theme].successT08} !important`" outlined) {{ $t('arranged') }}
            v-chip.button-AA-tiny.text-uppercase(v-else-if="isFailed" x-small color="danger400" :style="`height: 20px; border-radius: 10px; background-color: ${$vuetify.theme.themes[$theme].dangerT08} !important`" outlined) {{ $t('failed') }}
            v-chip.button-AA-tiny.text-uppercase(v-else-if="isMatching" x-small color="info400" :style="`height: 20px; border-radius: 10px; background-color: ${$vuetify.theme.themes[$theme].infoT08} !important`" outlined) {{ $t('matching') }}
          template(v-if="lead.status === 'shipped'")
            v-chip.button-AA-tiny.text-uppercase.mr-1(x-small color="warning500" style="height: 20px; border-radius: 10px;" dark) {{ $t('shipping') }}
          template(v-if="lead.status === 'received'")
            v-chip.button-AA-tiny.text-uppercase.mr-1(x-small color="basic500" style="height: 20px; border-radius: 10px;" dark) {{ $t('delivered') }}
          v-spacer
          v-btn(color="transparent" small icon @click="showPrintDialog = true" data-v-step='TourOrderDetails-2')
            eva-icon.mb-n1(name="printer-outline" :fill="$vuetify.theme.themes[$theme].primary700" width="22" height="22")
          v-menu(left :offset-y='true')
            template(v-slot:activator='{ on }')
              v-btn.ml-2(color="transparent" small icon v-on="on" data-v-step='TourOrderDetails-3')
                eva-icon.mb-n1(name="share-outline" :fill="$vuetify.theme.themes[$theme].primary700" width="22" height="22")
            v-list(dense)
              v-list-item(@click="shareUrlToWA")
                v-list-item-title.s2.basic800--text {{ $t('share_receipt_whatsapp') }}
              v-list-item(@click="openRiderListDialog = true")
                v-list-item-title.s2.basic800--text {{ $t('share_order_to_rider') }}
              v-list-item(@click="copyUrl" v-clipboard:copy="getShareLinkURL()")
                v-list-item-title.s2.basic800--text {{ $t('copy_receipt_link') }}
          template(v-if="hasRecipient")
            v-menu(left :offset-y='true')
              template(v-slot:activator='{ on }')
                v-btn.ml-2(color="transparent" small icon v-on="on" data-v-step='TourOrderDetails-4')
                  v-icon(:color="$vuetify.theme.themes[$theme].primary700" size="24") mdi-whatsapp
              v-list(dense)
                v-list-item(@click="clickOpenWa('recipient')")
                  v-list-item-title.s2.basic800--text {{ $t('whatsapp_recipient') }}
                v-list-item(@click="clickOpenWa('customer')")
                  v-list-item-title.s2.basic800--text {{ $t('whatsapp_customer') }}
          template(v-else)
            v-btn.ml-2(color="transparent" small icon @click="clickOpenWa('customer')" data-v-step='TourOrderDetails-4')
              v-icon(:color="$vuetify.theme.themes[$theme].primary700" size="24") mdi-whatsapp
          v-menu(left :offset-y='true')
            template(v-slot:activator='{ on }')
              v-btn.ml-1(color="transparent" small icon v-on="on")
                eva-icon.mb-n1(name="more-vertical-outline" :fill="$vuetify.theme.themes[$theme].primary700" width="22" height="22")
            v-list(dense)
              v-list-item(@click="openEditCustomerDialog = true")
                v-list-item-title.s2.basic800--text {{ $t('edit_customer_info') }}
              template(v-if="lead.status === 'processed' && lead.shipping_address && !lead.pickup && ((isCourier && (lead.shipping.status == 'new' || lead.shipping.status == 'error')) || !isCourier)")
                v-list-item(@click="openUpdateRecipientDetails = true")
                  v-list-item-title.s2.basic800--text {{ $t('edit_recipient_details') }}
              template(v-if="!lead.paid && lead.status !== 'partial_payment'")
                v-list-item(@click="openEditOrderDialog = true")
                  v-list-item-title.s2.basic800--text {{ $t('edit_order') }}
              v-list-item(v-if="lead.status === 'processed'" @click="openCancelledOrderDialog = true")
                v-list-item-title.s2.basic800--text {{ $t('cancel_order') }}
              v-menu(left :offset-x='true')
                template(v-slot:activator='{ on }')
                  v-list-item(v-on="on")
                    v-list-item-title.s2.basic800--text {{ $t('update_status') }}
                v-list.pa-0(dense)
                  template(v-for="(status, index) in statusSelections()")
                    v-list-item(:key="status.id" @click="updateStatus(status.id)")
                      v-list-item-title.s2.basic800--text {{ status.name }}
        div.px-4
          template(v-if="lead.products.length > 0")
            div.s1.primary--text.mt-4 {{ $t('order_items') }}
            template(v-for="product in lead.products")
              order-item-product(:product="product")
              v-divider.basic300
          v-layout.my-6.px-2.pt-2(v-if="isFetchingInvoice")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="3" :size="50" color="basic600" indeterminate)
          template(v-else-if="invoice")
            v-row.my-4(no-gutters)
              v-col.pt-1
                div.s2.basic600--text(v-if="lead.cod && lead.paid")
                  div {{ $t('cash_on_delivery') }}
                div.s2.basic600--text(v-if="lead.pay_at_shop && lead.paid")
                  div {{ $t('pay_at_shop') }}
              v-col(cols="8")
                div.d-flex.pt-1(v-if="subtotalAmount > 0")
                  div.p2.primary--text {{ $t('subtotal') }}
                  v-spacer
                  div.p2.primary--text {{ subtotalAmount | displayPrice }}
                div.d-flex.pt-1(v-if="shippingFeeAmount > 0")
                  div.p2.primary--text {{ $t('shipping') }}
                  v-spacer
                  div.p2.primary--text {{ shippingFeeAmount | displayPrice }}
                div.d-flex.pt-1(v-if="taxFeeAmount > 0")
                  div.p2.primary--text {{ $t('tax') }}
                  v-spacer
                  div.p2.primary--text {{ taxFeeAmount | displayPrice }}
                div.d-flex.pt-1(v-if="serviceFeeAmount > 0")
                  div.p2.primary--text {{ $t('service_fee') }}
                  v-spacer
                  div.p2.primary--text {{ serviceFeeAmount | displayPrice }}
                div.d-flex.pt-1(v-if="discountAmount > 0")
                  div.p2.primary--text {{ $t('discount') }}
                  v-spacer
                  div.p2.danger500--text - {{ discountAmount | displayPrice }}
                div.d-flex.pt-1(v-if="promoDiscountAmount > 0")
                  div.p2.primary--text {{ $t('promo_discount') }}
                  v-spacer
                  div.p2.danger500--text - {{ promoDiscountAmount | displayPrice }}
                template(v-if="paidAmount > 0")
                  div.d-flex.pt-1
                    div.s2.primary--text {{ $t('total_paid') }}
                    v-spacer
                    div.s2.primary--text {{ paidAmount | displayPrice }}
                  div.d-flex.pt-1(v-if="balanceAmount > 0")
                    div.s2.info500--text {{ $t('balance_due') }}
                    v-spacer
                    div.s2.info500--text {{ balanceAmount | displayPrice }}
                div.d-flex.pt-1(v-else)
                  div.s2.info500--text {{ $t('total_due') }}
                  v-spacer
                  div.s2.info500--text {{ totalAmount | displayPrice }}
        div.pa-4.mx-4(v-if="!lead.paid && (lead.cod || lead.pay_at_shop)" :style="`background-color: ${$vuetify.theme.themes[$theme].infoT08}`")
          div.d-flex.align-center
            div
              div.s2.info500--text(v-if="lead.cod") {{ $t('cash_on_delivery') }}
              div.s2.info500--text(v-if="lead.pay_at_shop") {{ $t('pay_at_shop') }}
              div.c1.info500--text {{ $t('please_ensure_collect_payment') }}
            v-spacer
            div.pl-3
              v-chip.button-AA-tiny.text-uppercase(v-if="lead.status !== 'received'" x-small label color="info400" style="height: 24px; border-radius: 10px;" outlined @click="showMessage(['error', 'Update status to ‘Delivered’ to mark as paid'])") {{ $t('mark_as_paid') }}
              v-chip.button-AA-tiny.text-uppercase.white--text(v-else x-small label color="info500" style="height: 24px; border-radius: 10px;" link @click="openMarkAsPaid = true") {{ $t('mark_as_paid') }}
        v-divider.basic300(v-else style="border: solid;")
        div.pa-4
          div.s1.primary--text {{ $t('fulfilment') }}
          template(v-if="lead.shipping_address")
            v-layout.my-6.px-2.pt-2(v-if="isFetchingShipping")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="3" :size="50" color="basic600" indeterminate)
            v-row.mt-2(v-else no-gutters)
              //- template(v-if="yezzaShipping && yezzaShipping.fulfilment")
              template(v-if="isArranged && yezzaShipping && yezzaShipping.fulfilment")
                v-col
                  v-img(:src="yezzaShipping.fulfilment.meta_data.shipping_logo" contain max-width="100" max-height="35")
                  div.c1.basic600--text.mt-4 {{ $t('ref_id') }}: {{ yezzaShipping.ref_id }}

                  template(v-if="lead.shipping.shipping_method === 'manual' && (lead.shipping.selected_option || lead.shipping.zone_name)")
                    div.c1.basic600--text.mt-4 {{ $t('customer_selection') }}
                    div.p2.basic600--text.mt-1(v-if="zoneCount > 1 && lead.shipping.zone_name") {{ $t('zone') }}: {{ lead.shipping.zone_name }}
                    div.p2.basic600--text.mt-1(v-if="lead.shipping.shipping_method === 'manual' && lead.shipping.selected_option") {{ $t('rate') }}: {{ lead.shipping.selected_option }}

                  template(v-if="lead.asking_delivery_date || lead.asking_delivery_time")
                    div.p2.basic600--text.mt-4 {{ $t('scheduled_for') }}
                    div.d-flex.align-center.mt-1(v-if="lead.asking_delivery_date")
                      eva-icon.mb-n1.mr-1(name="calendar-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="15" height="15")
                      div.p2.basic600--text {{ lead.asking_delivery_date | displayDate }}
                    div.d-flex.align-center.mt-1(v-if="lead.asking_delivery_time")
                      eva-icon.mb-n1.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="15" height="15")
                      div.p2.basic600--text {{ lead.asking_delivery_time | displayTime }}

                v-col
                  v-chip.button-AA-tiny.text-uppercase(v-if="lead.status === 'processed'" x-small color="success400" :style="`height: 20px; border-radius: 10px; background-color: ${$vuetify.theme.themes[$theme].successT08} !important`" outlined) {{ $t('arranged') }}
                  v-chip.button-AA-tiny.text-uppercase(v-if="lead.status === 'shipped'" x-small color="warning500" style="height: 20px; border-radius: 10px;" dark) {{ $t('shipping') }}
                  v-chip.button-AA-tiny.text-uppercase(v-if="lead.status === 'received'" x-small color="basic500" style="height: 20px; border-radius: 10px;" dark) {{ $t('delivered') }}
                  template(v-if="yezzaShipping.fulfilment.shipping_method === 'ys_courier'")
                    div.d-flex.align-center.mt-4
                      eva-icon.mb-n1.mr-1(name="car-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                      div.p2.basic700--text.text-capitalize {{ yezzaShipping.fulfilment.meta_data.service_type }}
                    div.d-flex.align-center.mt-2
                      eva-icon.mb-n1.mr-1(name="calendar-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                      div.p2.basic700--text {{ yezzaShipping.delivery_at | displayDate }}
                    div.p2.basic700--text {{ lead.shipping.tracking_id }}
                  template(v-else)
                    div.d-flex.align-center.mt-4
                      v-icon.mr-1(color="basic700" size="15") {{ yezzaShipping.fulfilment.meta_data.service_type === 'car' ? 'mdi-car-side' : 'mdi-moped-outline' }}
                      div.p2.basic700--text.text-capitalize {{ yezzaShipping.fulfilment.meta_data.service_type }}
                    div.d-flex.align-center.mt-2
                      eva-icon.mb-n1.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                      div.p2.basic700--text(v-if="lead.is_ASAP") {{ yezzaShipping.delivery_at | displayDate }} (ASAP)
                      div.p2.basic700--text(v-else) {{ yezzaShipping.delivery_at | convertServerDate }}
                    
                v-col(cols="12")
                  v-divider.basic300.mb-3.mt-4
                  div.d-flex.align-center.justify-space-around
                    template(v-if="yezzaShipping.fulfilment.shipping_method === 'ys_courier'")
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="clickDownloadAWB(yezzaShipping.id)")
                        eva-icon.mb-n1(name="download-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].info500")
                        div.info500--text.ml-2 {{ $t('download') }}
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="shareTrackingLinkToWA(yezzaShipping.fulfilment.title, lead.pid)")
                        v-icon(color="info500" size="16") mdi-whatsapp
                        div.info500--text.ml-2 {{ $t('share') }}
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="copyTrackingNo" v-clipboard:copy="lead.shipping.tracking_id")
                        eva-icon.mb-n1(name="copy-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].info500")
                        div.info500--text.ml-2 {{ $t('copy') }}
                    template(v-else)
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="openTrackingLink")
                        eva-icon.mb-n1(name="map-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].info500")
                        div.info500--text.ml-2 {{ $t('track') }}
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="shareTrackingLinkToWA(yezzaShipping.fulfilment.title, lead.pid)")
                        v-icon(color="info500" size="16") mdi-whatsapp
                        div.info500--text.ml-2 {{ $t('share') }}
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="copyTrackingNo" v-clipboard:copy="lead.shipping.on_demand_details")
                        eva-icon.mb-n1(name="copy-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].info500")
                        div.info500--text.ml-2 {{ $t('copy') }}
                      
              template(v-else)
                v-col(v-if="lead.shipping")
                  template(v-if="lead.shipping.shipping_method === 'easyparcel'")
                    v-img(:src="require('@/assets/images/logo_easyparcel_long.png')" contain max-width="100" max-height="35")
                  template(v-if="lead.shipping.shipping_method === 'zepto'")
                    v-img(:src="require('@/assets/images/logo_zeptoexpress.png')" contain max-width="100" max-height="35")
                  template(v-if="lead.shipping.shipping_method === 'ys_localdelivery' || lead.shipping.shipping_method === 'ys_courier'")
                    template(v-if="yezzaShipping")
                      v-img(v-if="yezzaShipping.lead_selection" :src="yezzaShipping.lead_selection.shipping_logo" contain max-width="100" max-height="35")
                      v-img(v-else-if="yezzaShipping.fulfilment" :src="yezzaShipping.fulfilment.meta_data.shipping_logo" contain max-width="100" max-height="35")
                  template(v-if="lead.shipping.shipping_method === 'manual' && (lead.shipping.selected_option || lead.shipping.zone_name)")
                    div.p2.basic700--text.mt-1(v-if="lead.pickup") {{ $t('self_pickup') }}
                    div.p2.basic700--text(v-if="zoneCount > 1 && lead.shipping.zone_name") Zone: {{ lead.shipping.zone_name }}
                    div.p2.basic700--text.mt-1(v-if="lead.shipping.shipping_method === 'manual' && lead.shipping.selected_option") {{ $t('rate') }}: {{ lead.shipping.selected_option }}
                  template(v-if="lead.asking_delivery_date || lead.asking_delivery_time")
                    div.p2.basic600--text.mt-4 {{ $t('scheduled_for') }}Scheduled for
                    div.d-flex.align-center.mt-1(v-if="lead.asking_delivery_date")
                      eva-icon.mb-n1.mr-1(name="calendar-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                      div.p2.basic700--text {{ lead.asking_delivery_date | displayDate }}
                    div.d-flex.align-center.mt-1(v-if="lead.asking_delivery_time")
                      eva-icon.mb-n1.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                      div.p2.basic700--text {{ lead.asking_delivery_time | displayTime }}

                template(v-if="!lead.pickup && lead.status === 'processed'")
                  template(v-if="lead.shipping && !lead.shipping.tracking_id && !lead.shipping.on_demand && $currency.code === 'MYR'")
                    template(v-if="isCourier || isYezzaShipping")
                      v-col(v-if="isCourier && (lead.shipping.status == 'new' || lead.shipping.status == 'error')")
                        v-btn.button-AA-small(data-v-step='TourOrderDetails-5' color="success500" dark small block height="32" @click="clickOpenShipItemDialog()") {{ $t('arrange_shipment') }}
                      v-col(v-if="isYezzaShipping && hasYezzaShipping && !isFailed && (lead.shipping.status == 'new' || lead.shipping.status == 'error')")
                        v-btn.button-AA-small(data-v-step='TourOrderDetails-5' color="success500" dark small block height="32" @click="clickArrangeShipment()") {{ $t('arrange_shipment') }}
                      v-col(v-if="isYezzaShipping && hasYezzaShipping && isFailed")
                        v-chip.button-AA-tiny.text-uppercase.mb-4(x-small color="danger400" :style="`height: 20px; border-radius: 10px; background-color: ${$vuetify.theme.themes[$theme].dangerT08} !important`" outlined) {{ $t('failed') }}
                        v-btn.button-AA-small(data-v-step='TourOrderDetails-5' color="success500" dark small block height="32" @click="clickArrangeShipment()") Arrange again
                      v-col(v-if="isYezzaShipping && hasYezzaShipping && isMatching")
                        v-chip.button-AA-tiny.text-uppercase.mb-4(x-small color="info400" :style="`height: 20px; border-radius: 10px; background-color: ${$vuetify.theme.themes[$theme].infoT08} !important`" outlined) {{ $t('matching') }}
                        div.d-flex.align-center.mt-4(v-if="yezzaShipping && yezzaShipping.fulfilment")
                          v-icon.mr-1(color="basic700" size="15") {{ yezzaShipping.fulfilment.meta_data.service_type === 'car' ? 'mdi-car-side' : 'mdi-moped-outline' }}
                          div.p2.basic700--text.text-capitalize {{ yezzaShipping.fulfilment.meta_data.service_type }}
                        div.d-flex.align-center.mt-2(v-if="yezzaShipping")
                          eva-icon.mb-n1.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                          div.p2.basic700--text(v-if="lead.is_ASAP || (lead.is_ASAP === null && !yezzaShipping.delivery_at)") ASAP
                          div.p2.basic700--text(v-else) {{ yezzaShipping.delivery_at | convertServerDate }}
                    template(v-else)
                      v-col(v-if="hasCourier")
                        v-btn.button-AA-small(data-v-step='TourOrderDetails-5' color="success500" dark small block height="32" @click="openAddShipItemDialog = true") {{ $t('arrange_shipment') }}
                      v-col(v-if="hasYezzaShipping")
                        template(v-if="isFailed")
                          v-chip.button-AA-tiny.text-uppercase.mb-4(x-small color="danger400" :style="`height: 20px; border-radius: 10px; background-color: ${$vuetify.theme.themes[$theme].dangerT08} !important`" outlined) {{ $t('failed') }}
                          v-btn.button-AA-small(data-v-step='TourOrderDetails-5' color="success500" dark small block height="32" @click="clickArrangeShipment()") Arrange again
                        template(v-else-if="isMatching")
                          v-chip.button-AA-tiny.text-uppercase.mb-4(x-small color="info400" :style="`height: 20px; border-radius: 10px; background-color: ${$vuetify.theme.themes[$theme].infoT08} !important`" outlined) {{ $t('matching') }}
                          div.d-flex.align-center.mt-4(v-if="yezzaShipping && yezzaShipping.fulfilment")
                            v-icon.mr-1(color="basic700" size="15") {{ yezzaShipping.fulfilment.meta_data.service_type === 'car' ? 'mdi-car-side' : 'mdi-moped-outline' }}
                            div.p2.basic700--text.text-capitalize {{ yezzaShipping.fulfilment.meta_data.service_type }}
                          div.d-flex.align-center.mt-2(v-if="yezzaShipping")
                            eva-icon.mb-n1.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                            div.p2.basic700--text(v-if="lead.is_ASAP || (lead.is_ASAP === null && !yezzaShipping.delivery_at)") ASAP
                            div.p2.basic700--text(v-else) {{ yezzaShipping.delivery_at | convertServerDate }}
                        template(v-else)
                          v-btn.button-AA-small(data-v-step='TourOrderDetails-5' color="success500" dark small block height="32" @click="clickArrangeShipment()") {{ $t('arrange_shipment') }}

                template(v-if="lead.shipping && lead.status !== 'received' && ((lead.status === 'shipped' && lead.shipping.shipping_method === 'manual') || (lead.shipping.shipping_method === 'easyparcel' && (lead.shipping.status == 'pending' || lead.shipping.status == 'processing')))")
                  v-col(v-if="!lead.shipping.tracking_id && !lead.shipping.on_demand")
                    v-btn.button-AA-small(color="info500" dark small block height="32" @click="skipTracking = false; openAddTrackingCodeDialog = true") {{ $t('add_tracking_info') }}
                  v-col(v-else)
                    template(v-if="lead.shipping.tracking_id")
                      div.p2.basic700--text.font-weight-bold(v-if="lead.shipping.courier") {{ lead.shipping.courier }}
                      div.p2.basic700--text(v-if="lead.shipping.tracking_id") {{ lead.shipping.tracking_id }}
                        v-btn.button-Aa-tiny.custom-transform-class.text-none(color="textColorAccent" text x-small @click="skipTracking = false; openAddTrackingCodeDialog = true")
                          eva-icon(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="15" width="15" style="margin-top: 1px")
                    template(v-else-if="lead.shipping.on_demand")
                      div.p2.basic700--text.font-weight-bold(v-if="lead.shipping.on_demand") {{ lead.shipping.on_demand }}
                        v-btn.button-Aa-tiny.custom-transform-class.text-none(color="textColorAccent" text x-small @click="skipTracking = false; openAddTrackingCodeDialog = true")
                          eva-icon(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="15" width="15" style="margin-top: 1px")
                      div.p2.basic700--text(v-if="lead.shipping.on_demand_details") {{ lead.shipping.on_demand_details }}
            v-divider.basic300.mt-3
          v-row.mt-4(no-gutters)
            v-col(v-if="lead.shipping_address && !lead.pickup")
              div.p2.basic600--text {{ $t('recipient_address') }}
              div.p2.basic700--text.mt-1 {{ lead.shipping_address.name }}
              div.mt-1(@click="startClick(lead.shipping_address)" style="word-break: break-all")
                div.p2.basic700--text {{ lead.shipping_address.address_1 }},
                div.p2.basic700--text(v-if="lead.shipping_address.address_2") {{ lead.shipping_address.address_2 }},
                template(v-if="lead.shipping_address.area")
                  div.p2.basic700--text {{ lead.shipping_address.postcode }} {{ lead.shipping_address.area }},
                  div.p2.basic700--text {{ lead.shipping_address.suburb }}, {{ lead.shipping_address.city }},
                div.p2.basic700--text(v-else) {{ lead.shipping_address.postcode }} {{ lead.shipping_address.city }},
                div.p2.basic700--text {{ lead.shipping_address.state }}, {{ lead.shipping_address.country }}.
              div.p2.basic700--text.mt-1 {{ lead.shipping_address.phone | phoneFormat }}
              div(ref="copy")
            v-col
              div.p2.basic600--text {{ $t('customer') }}
              div.p2.basic700--text.mt-1 {{ lead.name }}
              div.p2.basic700--text {{ lead.phone | phoneFormat }}
              div.p2.basic700--text(v-if="lead.email") {{ lead.email }}
          template(v-if="lead.order_remarks && lead.order_remarks.order_message")
            v-divider.basic300.mt-4
            div.p2.basic600--text.mt-4 {{ $t('message') }}
            div.p2.basic700--text {{ lead.order_remarks.order_message }}
          template(v-if="lead.remarks")
            v-divider.basic300.mt-4
            div.p2.basic600--text.mt-4 {{ $t('remarks') }}
            div.p2.basic700--text {{ lead.remarks }}
        template(v-if="lead.extra_fields_data && lead.extra_fields_data.length > 0")
          v-divider.basic300(style="border: solid;")
          div.pa-4
            div.s1.primary--text.mb-2 {{ $t('additional_info') }}
            div.p2.primary--text.mt-1(v-for="field in lead.extra_fields_data" style="white-space: pre-wrap;") {{ field.name }}: {{ field.value }}
        template(v-if="transactions && transactions.length > 0")
          v-divider.basic300(style="border: solid;")
          div.pa-4
            div.s1.primary--text {{ $t('transaction_details') }}
            v-row.my-2(no-gutters v-for="(transaction, index) in transactions" :key="transaction.uid")
              v-col(cols="1" v-if="transactions.length > 1")
                div.p2.primary--text {{ index + 1 }}.
              v-col
                div.d-flex
                  div.p2.primary--text {{ $t('amount') }}: {{ transaction.amount | displayPrice }}
                  v-icon.ml-1(v-if="transaction.paid" small color="success400") mdi-check-circle-outline
                  v-icon.ml-1(v-else small color="danger400") mdi-minus-circle-outline
                div.p2.primary--text.mt-1(v-if="transaction.paid") {{ transaction.created | convertServerDate }}
                div.p2.primary--text.mt-1 {{ $t('gateway') }}: {{ transaction.gateway | paymentGatewayDisplay }}
                div.p2.primary--text.mt-1 {{ $t('reference_id') }}: {{ transaction.ref_id || '-' }}
      .modal
        edit-customer-info(v-if="openEditCustomerDialog" :open.sync="openEditCustomerDialog" :parentLead.sync="lead")
        edit-order(v-if="openEditOrderDialog" :open.sync="openEditOrderDialog" :parentLead.sync="lead")
        ship-item(v-if="openShipItemDialog" :open.sync="openShipItemDialog" :parentLead.sync="lead")
        add-ship-item-new(v-if="openAddShipItemDialog" :open.sync="openAddShipItemDialog" :parentLead.sync="lead")
        rider-list(v-if="openRiderListDialog" :open.sync="openRiderListDialog" :leads.sync="riderLeads")
        add-tracking-code(v-if="openAddTrackingCodeDialog" :open.sync="openAddTrackingCodeDialog" :parentLead.sync="lead" :skippable="skipTracking" @markShipped="markAsShipped")
        edit-recipient-details(v-if="openUpdateRecipientDetails" :open.sync="openUpdateRecipientDetails" :parentLead.sync="lead")
        arrange-shipment(v-if="openArrangeShipmentDialog" :open.sync="openArrangeShipmentDialog" :parentLead.sync="lead" :parentYezzaShipping.sync="yezzaShipping" @updateYsId="handleUpdateYsId($event)" @refetchLead="fetchLeadShipping" @refetchYezzaShipping="checkYezzaShipping" @closeDialog="showModal = false")
        //- tracking-view(v-if="openTrackingViewDialog && lead.shipping" :open.sync="openTrackingViewDialog" :link="lead.shipping.on_demand_details")
        y-dialog(v-model='openMarkAsPaid', max-width='290' persistent)
          v-card
            v-card-title.h6.basic800--text.px-4 Mark as paid
            v-card-text.p2.primary500--text.px-4 {{ totalAmount | displayPrice }} was paid by&nbsp;
              span(v-if="lead.cod") {{ $t('cash_upon_delivery') }}
              span(v-if="lead.pay_at_shop") {{ $t('cash_upon_pickup') }}
            v-card-actions.px-4.pb-4
              v-spacer
              v-btn.mr-2(color='white' text small @click='openMarkAsPaid = false')
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn(color='info500' depressed small height="32" dark @click='markAsPaid' :loading="isLoading")
                .button-AA-small.basic100--text {{ $t('confirm') }}
        y-dialog(v-model='openCancelledOrderDialog', max-width='290' persistent)
          v-card
            v-card-title.h6.basic800--text.px-4 {{ $t('cancel_order') }}
            v-card-text.p2.primary500--text.px-4
              | {{ $t('cancel_order_confirmation') }}
            v-card-actions.px-4.pb-4
              v-spacer
              v-btn.mr-2(color='white' text small @click='openCancelledOrderDialog = false')
                .button-Aa-small.primary400--text {{ $t('no') }}
              v-btn(color='danger500' depressed small height="32" dark @click='cancelledOrder' :loading="isLoading")
                .button-AA-small.basic100--text {{ $t('yes') }}
        y-dialog(v-if="lead.shipping" v-model='openRetryShipItemDialog', max-width='320' persistent)
          v-card
            v-card-title.h6.danger500--text.px-4 {{ $t('shipping_error') }} !
            v-card-text.p2.primary500--text.px-4
              | {{ $t('shipping_error_desc', { method: $options.filters.shippingMethodDisplay(lead.shipping.shipping_method) }) }}
            v-card-actions.px-4.pb-4
              v-spacer
              v-btn.mr-2(color='white' text small @click='openAddShipItemDialog = true; openRetryShipItemDialog = false;')
                .button-Aa-small.primary400--text {{ $t('select_new') }}
              v-btn(color='info500' depressed dark small height="32" @click='openShipItemDialog = true; openRetryShipItemDialog = false;')
                .button-AA-small.basic100--text {{ $t('retry') }}
        y-dialog(v-model='showPrintDialog', max-width='290')
          v-card.pa-4
            div.mb-2.h6.basic800--text.text-center {{ $t('select_paper_size') }}
            v-row(no-gutters)
              v-col.pr-2(align="center")
                v-btn(color='textColorAccent' block depressed height=32 @click="printReceipt('small')")
                  .button-AA-small.basic100--text {{ $t('small_receipt') }}
              v-col.pl-2(align="center")
                v-btn(color='textColorAccent' block depressed height=32 @click="printReceipt('large')")
                  .button-AA-small.basic100--text {{ $t('a4_paper') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import OrderItemProduct from '@/components/ordermgmt/OrderItemProduct.vue'
import EditCustomerInfo from '@/components/dialogs/database/EditCustomerInfo.vue'
import EditOrder from '@/components/dialogs/database/EditOrder.vue'
import ShipItem from '@/components/dialogs/order/ShipItem.vue'
import AddShipItemNew from '@/components/dialogs/order/AddShipItemNew.vue'
import RiderList from '@/components/dialogs/order/RiderList.vue'
import AddTrackingCode from '@/components/dialogs/order/AddTrackingCode.vue'
import EditRecipientDetails from '@/components/dialogs/order/EditRecipientDetails.vue'
import ArrangeShipment from '@/components/dialogs/yezzashipping/ArrangeShipment.vue'
//- NOTE: Not in use due to issue with unresponsive button in iframe
// import TrackingView from '@/components/dialogs/yezzashipping/TrackingView.vue'

export default {
  name: 'OrderItemDetails',
  components: { OrderItemProduct, EditCustomerInfo, EditOrder, ShipItem, AddShipItemNew, RiderList, AddTrackingCode, EditRecipientDetails, ArrangeShipment },
  props: ['open', 'parentLead'],
  data: () => ({
    isLoading: false,
    isFetchingInvoice: false,
    isFetchingTransaction: false,
    isFetchingShipping: false,
    invoice: null,
    transactions: null,
    skipTracking: false,
    openEditCustomerDialog: false,
    openEditOrderDialog: false,
    openCancelledOrderDialog: false,
    openRetryShipItemDialog: false,
    openShipItemDialog: false,
    openAddShipItemDialog: false,
    openRiderListDialog: false,
    openMarkAsPaid: false,
    openAddTrackingCodeDialog: false,
    openUpdateRecipientDetails: false,
    openArrangeShipmentDialog: false,
    openTrackingViewDialog: false,
    showPrintDialog: false,
    yezzaShipping: null,
    shippingArranged: false
  }),
  computed: {
    ...mapGetters({
      zoneCount: 'orders/getZoneCount',
      view: 'orders/getOrderView',
      orderTempData: 'tours/getOrderTempData',
      shipments: 'orders/getShipments'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('update:parentLead', newValue)
      }
    },
    isReady() {
      if (this.lead.taggings.filter(f => f.tagging === 'ready').length > 0) {
        return true
      }
      return false
    },
    isArranged() {
      if (this.lead.taggings.filter(f => f.tagging === 'arranged').length > 0) {
        return true
      }
      return false
    },
    isFailed() {
      return this.lead.taggings[0] ? this.lead.taggings[0].tagging === 'failed' : false
    },
    isMatching() {
      return this.lead.taggings[0] ? this.lead.taggings[0].tagging === 'matching' : false
    },
    hasCourier() {
      return this.shipments.easyparcel || this.shipments.zepto
    },
    hasYezzaShipping() {
      return this.shipments.yslocaldelivery || this.shipments.yscourier
    },
    isCourier() {
      return this.lead.shipping && ['easyparcel', 'zepto'].includes(this.lead.shipping.shipping_method)
    },
    isYezzaShipping() {
      return this.lead.shipping && ['ys_localdelivery', 'ys_courier'].includes(this.lead.shipping.shipping_method)
    },
    subtotalAmount() {
      if (!this.invoice) return 0
      return this.invoice.subtotal_amount
    },
    taxFeeAmount() {
      if (!this.invoice) return 0
      return this.invoice.tax_amount
    },
    serviceFeeAmount() {
      if (!this.invoice) return 0
      return this.invoice.service_fee
    },
    shippingFeeAmount() {
      if (!this.invoice) return 0
      return this.invoice.shipping_fee
    },
    discountAmount() {
      if (!this.invoice) return 0
      return this.invoice.total_discount
    },
    promoDiscountAmount() {
      if (!this.invoice) return 0
      return this.invoice.total_promo_discount
    },
    paidAmount() {
      if (!this.invoice) return 0
      return this.invoice.total_paid
    },
    totalAmount() {
      if (!this.invoice) return 0
      return this.invoice.total_amount
    },
    balanceAmount() {
      if (!this.invoice) return 0
      return this.invoice.total_amount - this.invoice.total_paid
    },
    hasRecipient() {
      if (this.lead.shipping_address && this.lead.shipping_address.phone) {
        if (this.lead.phone.endsWith(this.lead.shipping_address.phone)) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    riderLeads() {
      return [this.lead]
    }
  },
  mounted() {
    this.fetchInvoice()
    this.fetchTransactions()
    this.checkYezzaShipping()
    // setTimeout(() => {
    //   this.orderTourCheck()
    // }, 2000)
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchInvoice() {
      this.isFetchingInvoice = true
      this.$axios
        .get(`/invoices/${this.lead.pid}/`)
        .then(response => {
          this.invoice = response.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingInvoice = false
        })
    },
    fetchTransactions() {
      this.isFetchingTransaction = true
      this.axios
        .get(`/transactions?lead=${this.lead.id}&company=${this.lead.company}`)
        .then(response => {
          this.transactions = response.data.results
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingTransaction = false
        })
    },
    fetchLeadShipping() {
      this.axios
        .get(`/leads/${this.lead.pid}`)
        .then(response => {
          this.$set(this.lead, 'shipping', response.data.shipping)
          this.$set(this.lead, 'taggings', response.data.taggings)
        })
        .catch(() => {})
      this.isFetchingShipping = true
      this.$axios
        .get(`/shipping/yezzashipping/${this.lead.shipping.yezzashipping}`)
        .then(resp => {
          this.yezzaShipping = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingShipping = false
        })
    },
    checkYezzaShipping() {
      if (this.lead.shipping && this.lead.shipping.yezzashipping) {
        this.isFetchingShipping = true
        this.$axios
          .get(`/shipping/yezzashipping/${this.lead.shipping.yezzashipping}`)
          .then(resp => {
            // Check if ys fulfilment is null (means failed) or has receipt_no (means arranged) but lead shipping status still matching (need to update current data)
            if (this.isMatching && (!resp.data.fulfilment || resp.data.receipt_no)) {
              this.$store.commit('riders/updateRefetchOneOrder', this.lead.pid)
            }
            this.yezzaShipping = resp.data
          })
          .catch(() => {})
          .finally(() => {
            this.isFetchingShipping = false
          })
      }
    },
    statusSelections() {
      if (this.lead.status === 'processed') {
        if (this.isReady) {
          return [
            { name: 'Processing', id: 'not-ready' },
            { name: 'Shipped', id: 'shipped' },
            { name: 'Delivered', id: 'received' }
          ]
        } else {
          return [
            { name: 'ready', id: 'ready' },
            { name: 'Shipped', id: 'shipped' },
            { name: 'Delivered', id: 'received' }
          ]
        }
      } else if (this.lead.status === 'shipped') {
        return [
          { name: 'Processing', id: 'processed' },
          { name: 'Delivered', id: 'received' }
        ]
      } else if (this.lead.status === 'received') {
        return [
          { name: 'Processing', id: 'processed' },
          { name: 'Shipped', id: 'shipped' }
        ]
      }
    },
    markAsReady() {
      this.$axios
        .put(`/leads/${this.lead.pid}/taggings/ready`)
        .then(resp => {
          if (this.lead.taggings.filter(f => f.tagging === 'ready').length > 0) {
            this.lead.taggings.filter(f => f.tagging === 'ready')[0] = resp.data
          } else {
            this.lead.taggings.push(resp.data)
          }
          if (this.view === 'kanban') {
            this.$emit('deleted', resp.data)
            this.showModal = false
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    markAsShipped() {
      this.isLoading = true
      this.axios
        .patch(`/leads/${this.lead.pid}/`, { status: 'shipped' })
        .then(resp => {
          this.lead.status = resp.data.status
          this.$emit('deleted', resp.data)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    markAsReceived() {
      this.isLoading = true
      this.axios
        .patch(`/leads/${this.lead.pid}/`, { status: 'received' })
        .then(resp => {
          this.lead.status = resp.data.status
          this.$emit('deleted', resp.data)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    markAsPaid() {
      const paymentAmount = this.balanceAmount / this.$currency.multiplier
      const amountInCent = parseFloat(paymentAmount)
        .toFixed(this.$currency.exponent)
        .replace('.', '')
      const params = {
        amount: amountInCent,
        gateway: 'direct',
        lead: this.lead.id,
        paid: true
      }
      if (amountInCent == 0) {
        this.showMessage(['error', this.$t('error_message.invalid_amount')])
        return
      }
      this.isLoading = true
      this.axios
        .post(`/transactions/`, params)
        .then(resp => {
          this.transactions = { ...resp.data }
          this.openMarkAsPaid = false
          this.fetchInvoice()
          this.$set(this.lead, 'paid', resp.data.paid)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    checkMarkShipped() {
      if (this.lead.shipping && this.lead.shipping.shipping_method === 'manual') {
        this.skipTracking = true
        this.openAddTrackingCodeDialog = true
      } else {
        this.markAsShipped()
      }
    },
    clickArrangeShipment() {
      if (this.lead.shipping) {
        if (this.lead.shipping.yezzashipping) {
          this.openArrangeShipmentDialog = true
        } else {
          this.$axios
            .post('/shipping/yezzashipping/', { shipping: this.lead.shipping.id })
            .then(resp => {
              this.yezzaShipping = resp.data
              this.openArrangeShipmentDialog = true
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
            })
        }
      }
    },
    startClick(address) {
      let container = this.$refs.copy
      let addr = `${address.address_1},${address.address_2 ? ` ${address.address_2},` : ''} ${address.postcode},${address.area ? ` ${address.area}, ${address.suburb},` : ''} ${address.city}, ${address.state}, ${address.country}`
      this.$copyText(addr, container)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.address_copied_to_clipboard')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.copy_address_failed')])
        })
    },
    updateStatus(status) {
      this.isLoading = true
      if (status === 'ready') {
        this.$axios
          .put(`/leads/${this.lead.pid}/taggings/ready`)
          .then(resp => {
            if (this.lead.taggings.filter(f => f.tagging === 'ready').length > 0) {
              this.lead.taggings.filter(f => f.tagging === 'ready')[0] = resp.data
            } else {
              this.lead.taggings.push(resp.data)
            }
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
      } else if (status === 'not-ready') {
        this.$axios
          .delete(`/leads/${this.lead.pid}/taggings/ready`)
          .then(() => {
            this.lead.taggings = this.lead.taggings.filter(f => f.tagging !== 'ready')
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
      } else {
        this.$axios
          .patch(`/leads/${this.lead.pid}/`, { status: status })
          .then(resp => {
            this.lead.status = resp.data.status
            if (resp.data.status !== 'processed') {
              this.$emit('deleted', resp.data)
              this.showModal = false
            }
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    cancelledOrder() {
      this.isLoading = true
      this.axios
        .patch(`/leads/${this.lead.pid}/`, { status: 'cancelled' })
        .then(resp => {
          this.$emit('deleted', resp.data)
          this.openCancelledOrderDialog = false
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clickOpenWa(to) {
      let phone = (this.lead.shipping_address && this.lead.shipping_address.phone) || this.lead.phone
      if (to === 'customer') {
        phone = this.lead.phone
      }
      window.open(`https://api.whatsapp.com/send?phone=${this.$options.filters.phoneSanitized(phone)}`)
    },
    shareUrlToWA() {
      window.open(`https://api.whatsapp.com/send?text=${this.getShareLinkURL()}`)
    },
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
    },
    getShareLinkURL() {
      if (this.$subdomain) {
        return `${this.$subdomain}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/invoices/${this.lead.pid}`
      } else {
        return `http://localhost:8080/invoices/${this.lead.pid}`
      }
    },
    clickOpenShipItemDialog() {
      if (this.lead.shipping.status == 'error') {
        this.openRetryShipItemDialog = true
        return
      }
      this.openShipItemDialog = true
    },
    printReceipt(size) {
      if (size === 'large') {
        let printUrl = `https://pdf.yezza.io/?url=http://localhost:8080/print-invoices/${this.lead.pid}&type=pdf&filename=receipt.pdf&waitUntil=networkidle0&printBackground=true&format=A4`
        if (this.$subdomain) {
          printUrl = `https://pdf.yezza.io/?url=${this.$subdomain}.yezza.io/print-invoices/${this.lead.pid}&type=pdf&filename=receipt.pdf&waitUntil=networkidle0&printBackground=true&format=A4`
        }
        if (this.$isMobile) {
          window.open(printUrl)
        } else {
          location.href = printUrl
        }
      } else if (size === 'small') {
        let printUrl = `https://pdf.yezza.io/?url=http://localhost:8080/print-invoices-small/${this.lead.pid}&type=pdf&filename=receipt.pdf&waitUntil=networkidle0&printBackground=true&width=65mm`
        if (this.$subdomain) {
          printUrl = `https://pdf.yezza.io/?url=${this.$subdomain}.yezza.io/print-invoices-small/${this.lead.pid}&type=pdf&filename=receipt.pdf&waitUntil=networkidle0&printBackground=true&width=65mm`
        }
        if (this.$isMobile) {
          window.open(printUrl)
        } else {
          location.href = printUrl
        }
      }
    },
    orderTourCheck() {
      if (this.orderTempData && (this.orderTempData.value === 'completed' || (this.orderTempData.extra_data && this.orderTempData.extra_data.orderDetails))) {
        return
      }
      if (this.lead.shipping_address && !this.lead.pickup && this.lead.status === 'processed' && this.lead.shipping) {
        if (!this.lead.shipping.tracking_id) {
          if (this.isCourier && (this.lead.shipping.status == 'new' || this.lead.shipping.status == 'error')) {
            this.$store.commit('tours/setOrderManagementDetailsTour')
            this.$nextTick(() => {
              this.$tours['YezzaTour'].start()
            })
          }
          if (!this.isCourier) {
            this.$store.commit('tours/setOrderManagementDetailsTour')
            this.$nextTick(() => {
              this.$tours['YezzaTour'].start()
            })
          }
        } else {
          this.$store.commit('tours/setOrderManagementDetailsTour')
          this.$nextTick(() => {
            this.$tours['YezzaTour'].start()
          })
        }
      }
    },
    handleUpdateYsId(id) {
      this.$set(this.lead.shipping, 'yezzashipping', id)
    },
    copyTrackingNo() {
      this.showMessage(['success', this.$t('success_message.tracking_number_copied_clipboard')])
    },
    shareTrackingLinkToWA(shipping_name, lead_pid) {
      const divider = '%0a-----------------------------------%0a'
      const message = `Hi, we have arranged your delivery with ${encodeURIComponent(shipping_name)}. You can track its real-time location here:%0ahttps://track.yezza.io/track/${lead_pid}${divider}`
      window.open(`https://api.whatsapp.com/send?text=${message}&phone=${this.yezzaShipping.receiver_address.phone}`)
    },
    clickDownloadAWB(id) {
      let exportDomain = process.env.VUE_APP_BASE_URL
      let link = `${exportDomain}/shipping/yezzashipping/download_awb?yezzashipping_ids=${id}`
      if (this.$isMobile) {
        window.open(link)
      } else {
        location.href = link
      }
    },
    openTrackingLink () {
      window.open(this.lead.shipping.on_demand_details, '_blank')
    }
  }
}
</script>

<style scoped>
.nocopy {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>

<i18n>
{
  "en": {
    "mark_ready": "Mark ready",
    "mark_picked_up": "Mark picked up",
    "mark_shipped": "Mark shipped",
    "mark_delivered": "Mark delivered",
    "created": "Created",
    "share_receipt_whatsapp": "Share receipt via whatsapp",
    "share_order_to_rider": "Share order details to own rider",
    "copy_receipt_link": "Copy receipt link",
    "whatsapp_recipient": "WhatsApp recipient",
    "whatsapp_customer": "WhatsApp customer",
    "edit_recipient_details": "Edit recipient details",
    "cancel_order": "Cancel order",
    "cancel_order_confirmation": "Are you sure you want to cancel this order?",
    "total_paid": "Total Paid",
    "total_due": "Total due",
    "please_ensure_collect_payment": "Please ensure to collect payment from your customer",
    "fulfilment": "Fulfilment",
    "scheduled_for": "Scheduled for",
    "add_tracking_info": "Add tracking info",
    "customer": "Customer",
    "additional_info": "Additional info",
    "cash_upon_delivery": "cash upon delivery",
    "cash_upon_pickup": "cash upon pickup",
    "shipping_error": "Shipping error",
    "shipping_error_desc": "There was error during prosessing your shipping. You can either retry with same shipper ({method}) or select new.",
    "failed": "Failed",
    "matching": "Matching"
  },
  "id": {
    "order": "Order",
    "mark_ready": "Tanda siap",
    "mark_picked_up": "Tanda diambil",
    "mark_shipped": "Tanda dikirim",
    "mark_delivered": "Tanda terkirim",
    "created": "Dibuat",
    "share_receipt_whatsapp": "Bagikan tanda terima lewat whatsapp",
    "share_order_to_rider": "Bagikan detail pesanan kepada rider sendiri",
    "copy_receipt_link": "Salin link tanda terima",
    "whatsapp_recipient": "WhatsApp penerima",
    "whatsapp_customer": "WhatsApp pelanggan",
    "edit_recipient_details": "Edit detail penerima",
    "cancel_order": "Batal order",
    "cancel_order_confirmation": "Anda yakin ingin batal order ini?",
    "total_paid": "Jumlah Pembayaran",
    "total_due": "Total yang harus dibayar",
    "please_ensure_collect_payment": "Pastikan untuk mengumpulkan pembayaran dari pelanggan kamu",
    "fulfilment": "Penyelesaian",
    "rate": "Tarif",
    "scheduled_for": "Dijadwalkan pada",
    "add_tracking_info": "Tambah info pelacakan",
    "customer": "Pelanggan",
    "additional_info": "Info tambahan",
    "cash_upon_delivery": "Cash on Delivery (COD) ",
    "cash_upon_pickup": "Bayar di toko",
    "shipping_error": "Eror pengiriman",
    "shipping_error_desc": "Terjadi kesalahan saat memproses pengiriman kamu. kamu dapat mencoba lagi dengan pengirim yang sama ({method}) atau memilih yang baru."
  }
}
</i18n>
